import { reactive } from "vue";

import { $_TableObject } from "@/config/table";

import { Helpers, Format, ObjectLib } from "@/core/utils";

export const TablePreset =
{
    default( uid, listName, store )
    {
        if( $_TableObject.hasOwnProperty( listName ) )
        {
            let $_permission = store.getters['auth/user/permissions']();

            let $_tablePresets = [], $_defaultPresets = $_TableObject[ listName ].table.presets.filter( p => ( p.id === store.getters['auth/user/detail'].currentAccount.organization.id ) || ( p.id === uid ));

            if( !$_defaultPresets?.length )
            {
                for( let preset of $_TableObject[ listName ].table.presets.filter( p => [ 'admin', 'recruiter', 'employer' ].includes( p.id ) && $_permission.includes( p.id ) ))
                {
                    $_tablePresets.push(
                    {
                        id      : preset.id,
                        name    : preset.name,
                        active  : false,
                        columns : preset.columns.map( column =>
                        {
                            let $_column = $_TableObject[ listName ].table.columns.find( c => c.id === column );

                            return ({ id: $_column.id, width: $_column.width })
                        })
                    })
                }
            }

            if( !$_tablePresets.length )
            {
                if( !$_defaultPresets?.length )
                {
                    $_defaultPresets = $_TableObject[ listName ].table.presets.filter( p => p.id === 'default' );
                }

                for( let $_defaultPreset of $_defaultPresets )
                {
                    $_tablePresets.push(
                    {
                        id      : $_defaultPreset.id,
                        name    : $_defaultPreset.name,
                        active  : false,
                        columns : $_defaultPreset.columns.map( column =>
                        {
                            let $_column = $_TableObject[ listName ].table.columns.find( c => c.id === column );

                            return ({ id: $_column.id, width: $_column.width })
                        })
                    })
                }
            }

            if( $_tablePresets.length === 1 )
            {
                $_tablePresets[0].active = true;
            }
            else
            {
                let customCompanyColumns = $_tablePresets.find( p => p.id === store.getters['auth/user/detail'].currentAccount.organization.id );

                if( customCompanyColumns )
                {
                    customCompanyColumns.active = true;
                }
                else
                {
                    $_tablePresets[0].active = true;
                }
            }

            return JSON.stringify({ presets: $_tablePresets });
        }
        else
        {
            console.error( `TABLE:defaultPreset => Table object with name '${listName}' does not exist!` );
        }
    },

    create( settings, ctx )
    {
        settings.presets.push( ctx.preset );

        Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( settings ));
    },

    update( settings, ctx )
    {
        ctx.preset.active && ( ctx.isLoaded.value = false );

        setTimeout( () =>
        {
            let currPresetIndex = settings.presets.findIndex( p => p.id === ctx.preset.id );

            settings.presets[currPresetIndex] = ctx.preset;

            Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( settings ));

            ctx.preset.active && ( ctx.isLoaded.value = true );

        }, 500 );
    },

    delete( settings, ctx )
    {
        let currPresetIndex = settings.presets.findIndex( p => p.id === ctx.id );

        settings.presets.splice( currPresetIndex, 1 );

        Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( settings ));
    },

    change( settings, ctx )
    {
        ctx.isLoaded.value = false;

        setTimeout( () =>
        {
            for( let preset of settings.presets )
            {
                preset.active = preset.id === ctx.id;
            }

            let customPreset = settings.presets.find( p => p.id === 'custom' );

            if( customPreset && !customPreset.active )
            {
                settings.presets = settings.presets.filter( p => p.id !== 'custom' );
            }

            Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( settings ));

            ctx.isLoaded.value = true;

        }, 500 );
    }
}

export const TableColumn =
{
    changeSize( settings, ctx )
    {
        let currPreset = settings.presets.find( f => f.active );
        let currColumn = currPreset.columns.find( c => c.id === ctx.column.id );

        currPreset.width = ctx.preset.width;
        currColumn.width = ctx.column.width;

        Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( settings ));
    },

    resetSize( settings, ctx )
    {
        let currPreset = settings.presets.find( f => f.active );

        for( let column of currPreset.columns )
        {
            delete column.width;
        }

        delete currPreset.width;

        Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( settings ));
    }
}

export const TableSelect =
{
    get defaultSelectSettings()
    {
        return { allSelected: false, selected: [] };
    },

    toggleBulkSelect( ListData, ctx )
    {
        if( !Helpers.Storage(undefined, 'get', ctx.storagePath ) )
        {
            Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( this.defaultSelectSettings ));
        }

        let storage = JSON.parse( Helpers.Storage( undefined, 'get', ctx.storagePath ) );

        if( storage.selected.includes( ctx.key ) )
        {
            storage.selected = storage.selected.filter( item => item !== ctx.key );
        }
        else
        {
            storage.selected.push( ctx.key );
        }

        Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( storage ));

        Helpers.ObjectSet( ListData, 'selectedItems', storage );
    },

    setBulkSelect( ListData, ctx )
    {
        if( !Helpers.Storage(undefined, 'get', ctx.storagePath ) )
        {
            Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( this.defaultSelectSettings ));
        }

        let storage = JSON.parse( Helpers.Storage(undefined, 'get', ctx.storagePath ) );

        if( ctx.allSelected )
        {
            storage.selected = [];
        }
        else
        {
            storage.selected = ListData.items.map( item => Helpers.ObjectGet( item, ctx.key ) );
        }

        storage.allSelected = ctx.allSelected;

        Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( storage ));

        Helpers.ObjectSet( ListData, 'selectedItems', storage );
    },

    clearBulkSelect( ListData, ctx )
    {
        Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( this.defaultSelectSettings ));

        Helpers.ObjectSet( ListData, 'selectedItems', this.defaultSelectSettings );
    }
}

export const Table =
{
    createObject( listName, options, storagePath )
    {
        if( $_TableObject.hasOwnProperty( listName ) )
        {
            //let $_cloneOptions = JSON.parse( JSON.stringify( $_TableObject[ listName ] ) );

            let $_storage      = JSON.parse( Helpers?.Storage( undefined, 'get', storagePath ) || '{}' );
            let $_cloneOptions = ObjectLib.clone( true, {}, $_TableObject[ listName ] );

            if( Object.keys( options ).length )
            {
                options.hasOwnProperty('grid')  && Object.assign( $_cloneOptions.grid, options.grid );
                options.hasOwnProperty('table') && Object.assign( $_cloneOptions.table, options.table );
            }

            $_cloneOptions.table.thead = reactive( $_cloneOptions.table.columns );

            if( $_storage?.customFields?.length )
            {
                for( let field of $_storage?.customFields )
                {
                    for( let column of field?.export?.columns )
                    {
                        column.data = ( item, ctx ) => { return item?.metadata?.[ field.id ] };
                    }

                    $_cloneOptions.table.thead.push( field );
                }
            }

            delete $_cloneOptions.table.columns;
            delete $_cloneOptions.table.presets;

            return $_cloneOptions;
        }
        else
        {
            console.error( `TABLE:createObject => Table object with name '${listName}' does not exist!` );
        }
    },

    defaultPreset()
    {
        return '{}'
    }
}